import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import ConfirmModal from '@/components/ConfirmModal'
import { toast } from '@/hooks/useToast'

import useRemoveCurriculum from '../mutations/useRemoveCurriculum'
import type { SimpleCurriculum } from '../types/simple-curriculum'

type RemoveCurriculumModalProps = {
  curriculum: SimpleCurriculum
  onClose: () => void
  onRemoveSuccess?: (curriculum: SimpleCurriculum) => void
}

const RemoveCurriculumModal = (props: RemoveCurriculumModalProps) => {
  const { t } = useTranslation('curriculumsManagement')

  const { mutate: remove, isPending } = useRemoveCurriculum({
    onSuccess: () => {
      props.onRemoveSuccess?.(props.curriculum)
      toast({
        variant: 'success',
        title: t('toast.single-remove-success', {
          NAME: props.curriculum.name
        })
      })
      props.onClose()
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.single-remove-error', {
          NAME: props.curriculum.name
        })
      })
    }
  })

  const handleConfirmClick = () => remove(props.curriculum.id)

  return (
    <ConfirmModal
      open
      onOpenChange={props.onClose}
      header={t('header.remove-curriculum')}
      subheader={
        <>
          <p>{t('help.want-to-remove-curriculum')}</p>
          <p>{t('help.action-cannot-be-undone')}</p>
        </>
      }
      confirmButton={
        <Button
          variant="danger"
          onClick={handleConfirmClick}
          loading={isPending}
        >
          {t('button.remove')}
        </Button>
      }
    />
  )
}

export default RemoveCurriculumModal
